import { render } from "./couponDetails.vue?vue&type=template&id=140d047d"
import script from "./couponDetails.vue?vue&type=script&lang=js"
export * from "./couponDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__